const COMPONENT_NAME = "carousel-selector";
const CLASS_SELECTOR = ".CarouselSelector";
const CLASS_ACTIVE = "is-active";
const PREV_SELECTOR = ".CarouselSelector-prev";
const NEXT_SELECTOR = ".CarouselSelector-next";
const INNER_SELECTOR = ".CarouselSelector-content";
const CHILD_SELECTOR = ".CarouselSelectorItem";

const instances = [];

function initialize(element, PageComponents) {
    const prevButton = element.querySelector(PREV_SELECTOR);
    const nextButton = element.querySelector(NEXT_SELECTOR);
    const innerElement = element.querySelector(INNER_SELECTOR);
    const items = innerElement.querySelectorAll(CHILD_SELECTOR);

    const callback = element.getAttribute('data-callback');

    const targetSelector = element.getAttribute('data-target');
    const targetElements = targetSelector && document.querySelectorAll(targetSelector);
    let activeIndex = 0;

    function sync(index) {
        let activeItem = null;
        items.forEach((item, i) => {
            const itemIndex = item.hasAttribute('data-index') ? item.getAttribute('data-index') : i;
            if (itemIndex === index) {
                item.classList.add(CLASS_ACTIVE);
                activeItem = item;
                activeIndex = i;
            } else {
                item.classList.remove(CLASS_ACTIVE);
            }
        });
        if (targetElements) {
            targetElements.forEach((e, i) => {
               e.classList.toggle(CLASS_ACTIVE, i === index);
            });
        }
        if (callback && window[callback]) {
            const callbackMethod = window[callback];
            if (callbackMethod instanceof Function) {
                callbackMethod(index, activeItem);
            }
        }
    }

    const elements = [];

    items.forEach((item, index) => {
        if (item.classList.contains(CLASS_ACTIVE)) activeIndex = index;

        function activate(e) {
            e.stopPropagation();
            e.preventDefault();

            sync(item.hasAttribute('data-index') ? item.getAttribute('data-index') : index);
        }

        item.addEventListener('click', activate);

        elements.push({
            index,
            item,
            activate
        });
    });

    prevButton && prevButton.addEventListener('click', (e) => {
        e.stopPropagation();
        e.preventDefault();
        activeIndex --;
        if (activeIndex < 0) activeIndex = elements.length - 1;
        elements[activeIndex].activate(e);
    });

    nextButton && nextButton.addEventListener('click', (e) => {
        e.stopPropagation();
        e.preventDefault();
        activeIndex ++;
        if (activeIndex >= elements.length) activeIndex = 0;
        elements[activeIndex].activate(e);
    });

    instances.push({
        element,
        sync
    });
}

export default {
    name: COMPONENT_NAME,
    instances,
    initialize
};
